import React from 'react';
import TextInput from "../textInput";
import TextAreaInput from "../textareaInput";
import FileInput from "../file-input";

const SectionFormCard = (
    {   sectionname,
        sectiontitle,
        handleSectionTitle,
        setSectionTitle,
        sectioncontent,
        handleSectionContent,
        setSectionContent,
        setFileinput,
        handleFileUpload
    }
    )=> { 
    return (
        <div className="card">
        <div className="card-body mb-auto">
          <h5>{sectionname}</h5>
          <TextInput
            handleInputSubmit = {handleSectionTitle}
            setInputValue = {setSectionTitle}
            inputValue = {sectiontitle}
          />
          <FileInput 
          setFileinput = {setFileinput}
          handleFileUpload = {handleFileUpload}/>
          <TextAreaInput
          handleSectionContent = {handleSectionContent}
          sectioncontent = {sectioncontent}
          setSectionContent = {setSectionContent}
          />
        </div>
      </div>
    );
  }
  
  export default SectionFormCard; 